export default __webpack_public_path__ + "static/media/EVEN_BG-HOVER.36d7e938.png";